import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AiAssistantModule } from 'src/app/shared/ai-assistant/ai-assistant.module';
import { UploadSingleResumeComponent } from './upload-single-resume.component';

@NgModule({
  declarations: [UploadSingleResumeComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule.forRoot(),
    PipesModule,
    AiAssistantModule,
    DropzoneModule
  ],
  exports: [UploadSingleResumeComponent],
  entryComponents: [UploadSingleResumeComponent]
})
export class UploadSingleResumeModule { }
